<template>
    <div class="gallery-browser">
        <div
            v-if="loading"
            :class="{ 'tall': galleries.length > 1 }"
            class="loader d-flex"
        >
            <div
                class="spinner-border text-primary m-auto"
                role="status"
            >
                <span class="sr-only">{{ __('Loading...') }}</span>
            </div>
        </div>
        <section
            class="content-component content-component-galleryCategory no-parallax"
            data-component="galleryCategory"
        >
            <Gallery
                v-for="gallery in galleries"
                :key="gallery.id"
                :gallery="gallery"
                :is-downloadable="isDownloadable"
                :is-title-clickable="isTitleClickable"
                :with-thumbnails="withThumbnails"
            />
        </section>

        <pagination
            v-if="meta !== null"
            :data="paginator"
            :limit="2"
            :show-disabled="true"
            @pagination-change-page="loadPage"
        >
            <span slot="prev-nav">
                <a @click="loadPrevious">
                    <svg class="icon icon-triangle-prev"><use xlink:href="#triangle-prev" /></svg>
                </a>
            </span>
            <span slot="next-nav">
                <a @click="loadNext">
                    <svg class="icon icon-triangle-next"><use xlink:href="#triangle-next" /></svg>
                </a>
            </span>
        </pagination>
    </div>
</template>
<script>
/*eslint-disable no-undef*/
import Gallery from './Gallery'

export default {
    name: 'GalleryBrowser',
    components: { Gallery },

    props: {
        endpoint: {
            type: String,
            required: true
        },
        withThumbnails: {
            type: Boolean,
            default: false
        },
        isDownloadable: {
            type: Boolean,
            default: false
        },
        isTitleClickable: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            galleries: [],
            meta: null,
            links: null,

            loading: true,
        }
    },

    computed: {
        paginator() {
            return {
                meta: this.meta,
                links: this.links
            }
        }
    },

    created() {
        if (this.meta === null) {
            this.loadInitial()
        }
    },

    methods: {
        async loadInitial() {
            await this.loadContent(1)

            this.$emit('meta-loaded', this.meta)
        },

        loadPrevious() {
            this.loadContent(this.meta.current_page - 1)
        },

        loadNext() {
            this.loadContent(this.meta.current_page + 1)
        },

        loadPage(page) {
            this.loadContent(page)
        },

        async loadContent(page) {
            this.loading = true

            try {
                const response = await axios.get(this.endpoint, {
                    params: { page }
                })

                this.galleries = response.data.data
                this.meta = response.data.meta
                this.links = response.data.links
            } catch (exception) {
                console.error(exception)
            }

            this.loading = false
        },
    }
}
</script>

<style lang="scss" scoped>
@use "sass:map";
@import "./resources/sass/_variables.scss";

.pagination {
    margin-bottom: 3rem;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0;
    justify-content: center;
}

::v-deep .page-item.pagination-page-nav {
    margin: 3px;

    &.active {
        &>.page-link {
            padding: 2px 0 0 0;
            font-weight: bold;
            background-color: $zh-suplementary-selected;
            border-color: $zh-suplementary-selected;
        }
    }

    &>.page-link {
        color: $zh-blue;
        display: flex !important;
        align-items: center;
        justify-content: center;
        width: 25px;
        height: 25px;
        padding: 0;
        font-size: 14px;
        border-radius: 12.5px;
        border: 1px solid transparent;
    }
}

::v-deep .page-item.pagination-prev-nav .page-link,
::v-deep .page-item.pagination-next-nav .page-link {
    border: none;
    padding: 0
}

::v-deep .page-item.pagination-prev-nav .page-link {
    margin-right: 10px;
}

::v-deep .page-item.pagination-next-nav .page-link {
    margin-left: 10px;
}

.icon-triangle-next, .icon-triangle-prev {
    width: 15px;
    height: 22px;
}

.gallery-browser {
    position: relative;
    min-height: 300px;
}

.loader {
    position: absolute;
    top: 0;
    width: 100%;
    min-height: 300px;

    &.tall {
        min-height: 555px;

        @media (max-width: map.get($grid-breakpoints, "md")) {
            min-height: 600px;
        }
    }
}
</style>
